import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Card } from 'react-bootstrap';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { makeRequest } from '../../utils/makeRequest';
import toastNotify from '../../utils/toastNotify';
import * as urls from '../../utils/urlConst'
import { useNavigate } from 'react-router-dom';
import { BiLoader, BiCheck, BiX } from "react-icons/bi";
import Textfield from '../../components/textField/TextField';
import { exceptionLog } from '../../utils/common';

const ChangePassword = () => {
    const [isLoader, setIsLoader] = useState(false);
    const navigate = useNavigate();
    const [password, setPassword] = useState<string>("")
    const [isCharacter8, setIsCharacter8] = useState<boolean>(false);
    const [isUpperCase, setIsUpperCase] = useState<boolean>(false);
    const [isLowerCase, setIsLowerCase] = useState<boolean>(false);
    const [isNumber, setIsNumber] = useState<boolean>(false);
    const [isSpecialChar, setIsSpecialChar] = useState<boolean>(false);

    const initialValues = {
        currentPwd: '',
        newPwd: '',
        confirmPwd: '',
    }

    const pwd = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/

    const validation = Yup.object({
        currentPwd: Yup.string().required('Current Password is a required field'),
        newPwd: Yup.string().min(8, 'Password must be at least 8 characters')
            .required('New Password is a required field')
            .matches(pwd, 'Password must contain at least one lowercase letter, one uppercase letter, one digit, one special character, and be at least 8 characters long')
            .notOneOf([Yup.ref('currentPwd')], 'New password cannot match Current password'),
        confirmPwd: Yup.string().min(8, 'Password must be at least 8 characters').required('Confirm Password is a required field').oneOf([Yup.ref('newPwd')], 'Passwords must match'),
    });

    const changePwd = async (val: any) => {
        try {
            setIsLoader(true);
            const payload = {
                OldPassword: val.currentPwd,
                NewPassword: val.confirmPwd,
            };
            const config = {};

            await makeRequest("POST", urls.changePassword, payload, config).then((result) => {
                if (result.STATUS === '0') {
                    toastNotify(result.MESSAGE, 'success');
                    navigate('/');
                } else {
                    toastNotify(result.MESSAGE, 'error');
                }
            })
        } catch (error: any) {
            if (error.status !== 403) {
                await exceptionLog(error, "Change password", "N");
            }
        } finally {
            setIsLoader(false);
        }
    };

    useEffect(() => {
        if (password.length >= 8) {
            setIsCharacter8(true);
        } else {
            setIsCharacter8(false);
        };
        if (/[A-Z]/.test(password)) {
            setIsUpperCase(true);
        } else {
            setIsUpperCase(false);
        };
        if (/[a-z]/.test(password)) {
            setIsLowerCase(true);
        } else {
            setIsLowerCase(false);
        };
        if (/[0-9]/.test(password)) {
            setIsNumber(true);
        } else {
            setIsNumber(false);
        };
        if ((/^[a-zA-Z0-9!@#%*)(+=._-]+$/).test(password)) {
            setIsSpecialChar(true);
        } else {
            setIsSpecialChar(false);
        };
    }, [password, setIsCharacter8, setIsUpperCase, setIsLowerCase, setIsNumber, setIsSpecialChar])

    return (
        <div>
            <div className="mb-3 d-flex align-items-center">
                <div>
                    <h2 className="text-base pe-md-2 mb-0">Change Password</h2>
                    {/* <div className='text-xs text-slate-500'>#{state.response.TicketData}'s details</div> */}
                </div>
                {/* <Button variant="outline-secondary ms-auto" className="btn-sm" onClick={() => navigate("/tickets")}>
                    <BiArrowBack className="me-2" />
                    Back
                </Button> */}
            </div>

            <Card>
                <Card.Body >
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validation}
                        onSubmit={(values) => {
                            changePwd(values);
                        }}
                    >
                        {({ values, handleChange, handleBlur, handleSubmit }) => {
                            return (
                                <form action="#" onSubmit={handleSubmit}>
                                    <Row>
                                        <Col xs={12} md={4}>
                                            <div>
                                                <Textfield
                                                    label="Current Password"
                                                    name="currentPwd"
                                                    type="password"
                                                    id="currentPwd"
                                                    size="small"
                                                    tabIndex={1}
                                                    maxLength={25}
                                                    required
                                                    disabled={isLoader}
                                                    value={values.currentPwd}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <ErrorMessage name="currentPwd" className='error-msg' component="div" />
                                            </div>

                                            <div className='mt-3'>
                                                <Textfield
                                                    label="New Password"
                                                    name="newPwd"
                                                    type="password"
                                                    id="newPwd"
                                                    size="small"
                                                    tabIndex={2}
                                                    maxLength={25}
                                                    required
                                                    disabled={isLoader}
                                                    value={values.newPwd}
                                                    onChange={(e) => { handleChange(e); setPassword(e.target.value) }}
                                                    onBlur={handleBlur}
                                                />

                                                <ErrorMessage name="newPwd" className='error-msg' component="div" />
                                            </div>

                                            <div className='mt-3'>
                                                <Textfield
                                                    label="Confirm Password"
                                                    name="confirmPwd"
                                                    type="password"
                                                    id="confirmPwd"
                                                    size="small"
                                                    tabIndex={3}
                                                    maxLength={25}
                                                    required
                                                    disabled={isLoader}
                                                    value={values.confirmPwd}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                <ErrorMessage name="confirmPwd" className='error-msg' component="div" />
                                            </div>

                                            <div className="d-flex justify-content-end mt-3 gap-2">
                                                <Button variant="orange" type='submit' className='btn-sm' disabled={isLoader} >{!isLoader ? 'Update' : <><BiLoader className='icon-loader text-white text-lg' /> Loading...</>}</Button>
                                            </div>
                                        </Col>
                                        <Col md={1} className='d-md-block d-none'></Col>

                                        <Col md={7}>
                                            <div className='text-md fw-semibold text-danger'>Password Policy</div>

                                            <ul className='ps-0'>
                                                <li className='text-sm text-slate-500'>{isCharacter8 ? <BiCheck className='text-lg text-success' /> : <BiX className='text-lg text-danger' />} Must contain at least 8 character.</li>
                                                <li className='text-sm text-slate-500'>{isUpperCase ? <BiCheck className='text-lg text-success' /> : <BiX className='text-lg text-danger' />} Must contain at least One Uppercase letter.</li>
                                                <li className='text-sm text-slate-500'>{isLowerCase ? <BiCheck className='text-lg text-success' /> : <BiX className='text-lg text-danger' />} Must contain at least One Lowercase letter.</li>
                                                <li className='text-sm text-slate-500'>{isNumber ? <BiCheck className='text-lg text-success' /> : <BiX className='text-lg text-danger' />} Must contain at least One number</li>
                                                <li className='text-sm text-slate-500'>{isSpecialChar ? <BiCheck className='text-lg text-success' /> : <BiX className='text-lg text-danger' />} Must contain at least One Special character (!#$%&()*+,-./:;=?@[])</li>
                                            </ul>
                                        </Col>
                                    </Row>
                                </form>
                            )
                        }}
                    </Formik>
                </Card.Body>
            </Card>
        </div>
    )
}

export default ChangePassword